import type { PropsWithChildren, ReactNode } from "react";

export function Card({ title, children }: PropsWithChildren<{ title?: ReactNode }>) {
  return (
    <section className="card shadow mb-4">
      {title && <header className="card-header py-3"><h2 className="h6 m-0 font-weight-bold text-primary">{title}</h2></header>}
      <div className="card-body">{children}</div>
    </section>
  );
}

